import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]
  
  connect() {
  }
  
  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }
  
  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest('.press-article-wrapper')
    const destroyField = wrapper.querySelector('input[name*="_destroy"]')
    if (destroyField) {
      destroyField.value = "1"
      wrapper.style.display = 'none'
    } else {
      wrapper.remove()
    }
  }
}